import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { RequestHeaders } from './utilities';
import { GetTwoFactorAuthenticationDetailsUrl, VerifyTwoFactorAuthenticationMethodUrl } from '../constants';
export var twoFactorAuthentication = function twoFactorAuthentication(api) {
  return {
    initiateSmsMethodVerification: function initiateSmsMethodVerification(requestQueryParams) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.authenticated().post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({
                  queryParams: requestQueryParams
                }, RequestHeaders));

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    initiateEmailMethodVerification: function initiateEmailMethodVerification(requestQueryParams) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api.authenticated().post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({
                  queryParams: requestQueryParams
                }, RequestHeaders));

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    finalizeSmsMethodVerification: function finalizeSmsMethodVerification(requestQueryParams) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return api.authenticated().post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({
                  queryParams: requestQueryParams
                }, RequestHeaders));

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    finalizeEmailMethodVerification: function finalizeEmailMethodVerification(requestQueryParams) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return api.authenticated().post(VerifyTwoFactorAuthenticationMethodUrl, {}, Object.assign({
                  queryParams: requestQueryParams
                }, RequestHeaders));

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    getDetails: function getDetails() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api.authenticated().get(GetTwoFactorAuthenticationDetailsUrl, {}, RequestHeaders);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  };
};